import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { useSelector } from 'react-redux'

import { isUserAgreementPopupOpenSelector } from './selectors'

const PopupBody = withSafeSuspense(lazy(async () => ({
  default: (await import('./popup_body')).PopupBody
})))

export const UserAgreementPopup = () => {
  const isOpen = useSelector(isUserAgreementPopupOpenSelector)

  if (!isOpen) return null

  return <PopupBody />
}
